import {
  Box,
  FormControl,
  FormLabel,
  Skeleton,
  TextField,
} from '@mui/material';
import { PageLayout } from '../../../shared/layouts';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ConfirmNavigationHook } from '@gvdasa/components-confirm';
import { ApiException } from '../../../shared/services/api/ApiException';
import { confirm, feedback } from '../../../shared/services';
import { FerramentasDeDetalhe, Section } from '../../../shared/components';
import {
  C4ModelUsuariosService,
  C4Usuarios,
} from '../../../shared/services/api/c4-model/UsuariosService';
import { schemaBuilder } from '../../../shared/services/form-validation/Yup';
import { useFormik } from 'formik';

const validationSchema = schemaBuilder.object().shape({
  nome: schemaBuilder.string().required().min(3),
  descricao: schemaBuilder.string().required().min(3),
});

export const DetalheUsuarios: React.FC = () => {
  const { id = 'novo' } = useParams<'id'>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [saveAndNew, setSaveAndNew] = useState(false);
  const gvConfirmation = new ConfirmNavigationHook({});
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      nome: '',
      descricao: '',
    },
    validationSchema,
    onSubmit: async (values: C4Usuarios) => {
      setIsLoading(true);
      setSaveAndNew(false);
      feedback('Salvando...', 'loading');

      if (id === 'novo') {
        C4ModelUsuariosService.create(values)
          .then(() => {
            feedback('Usuário criado com sucesso', 'success');
            if (saveAndNew) {
              formik.resetForm();
              navigate('/c4-usuarios/detalhe/novo');
            } else {
              navigate('/c4-usuarios');
            }
          })
          .catch((error) => {
            if (error instanceof ApiException) {
              feedback(error.message, 'error');
            }
          });
      } else {
        C4ModelUsuariosService.updateById(id, values)
          .then(() => {
            feedback('Usuário atualizado com sucesso', 'success');
            if (saveAndNew) {
              formik.resetForm();
              navigate('/c4-usuarios/detalhe/novo');
            } else {
              navigate('/c4-usuarios');
            }

          })
          .catch((error) => {
            if (error instanceof ApiException) {
              feedback(error.message, 'error');
            }
          });
      }
      setIsLoading(false);
    },
  });

  useEffect(() => {
    if (id === 'novo') {
      setIsLoading(false);
    } else {
      C4ModelUsuariosService.getById(id).then((data) => {
        setIsLoading(false);
        if (data instanceof ApiException) {
          feedback(data.message, 'error');
        } else {
          formik.setValues({
            nome: data.nome,
            descricao: data.descricao,
          });
        }
      });
    }
  }, [id]);

  useEffect(() => {
    gvConfirmation.componentDidMount();

    return () => {
      gvConfirmation.componentWillUnmount();
    };
  }, []);

  const handleNovo = () => {
    formik.resetForm();
    navigate('/c4-usuarios/detalhe/novo');
  };

  const handleSaveAndNew = () => {
    setSaveAndNew(true);
    formik.submitForm();
  };

  // const handleSubmit = useCallback(() => {
  //   setIsLoading(true);
  //   setSaveAndNew(false);
  //   feedback('Salvando...', 'loading');
  //   if (id === 'novo') {
  //     C4ModelUsuariosService.create({
  //       nome: formik.values.nome,
  //       descricao: formik.values.descricao,
  //     }).then((data) => {
  //       if (data instanceof ApiException) {
  //         feedback(data.message, 'error');
  //       } else {
  //         feedback('Usuário criado com sucesso', 'success');
  //         if (saveAndNew) {
  //           handleNovo();
  //         } else {
  //           navigate('/c4-usuarios');
  //         }
  //       }
  //     });
  //   } else {
  //     C4ModelUsuariosService.updateById(id, {
  //       nome: formik.values.nome,
  //       descricao: formik.values.descricao,
  //     }).then((data) => {
  //       if (data instanceof ApiException) {
  //         feedback(data.message, 'error');
  //       } else {
  //         feedback('Usuário atualizado com sucesso', 'success');
  //         if (saveAndNew) {
  //           handleNovo();
  //         } else {
  //           navigate('/c4-usuarios');
  //         }
  //       }
  //     });
  //   }
  // }, [
  //   id,
  //   formik.values.nome,
  //   formik.values.descricao,
  //   saveAndNew,
  //   navigate,
  //   handleNovo,
  // ]);

  const handleDelete = useCallback(() => {
    const handleConfirmDelete = () => {
      feedback('Excluindo...!', 'loading');
      C4ModelUsuariosService.deleteById(id).then((result) => {
        if (result instanceof ApiException) {
          feedback(result.message, 'error');
        } else {
          feedback(`${formik.values.nome} Excluído com sucesso!`, 'success');
          navigate('/c4-usuarios');
        }
      });
    };
    confirm(
      `Tem certeza que deseja excluir ${formik.values.nome}?`,
      'delete',
      handleConfirmDelete
    );
  }, [navigate, id, formik.values.nome]);

  return (
    <PageLayout
      title={id === 'novo' ? 'Novo usuário' : formik.values.nome}
      tools={
        <FerramentasDeDetalhe
          mostrarBotaoDeSalvar
          // desabilitarBotaoApagar={permitirExcluirTermoPadrao}
          // desabilitarBotaoDeSalvar={permitirEditarTermoPadrao}
          mostrarBotaoDeVoltar
          mostrarBotaoDeSalvarENovo={id == 'novo'}
          isBotaoDeNovoLoading={isLoading}
          isBotaoDeApagarLoading={isLoading}
          isBotaoDeSalvarLoading={isLoading}
          isBotaoDeSalvarENovoLoading={isLoading}
          mostrarBotaoDeNovo={id !== 'novo'}
          mostrarBotaoDeApagar={id !== 'novo'}
          mostrarDivider
          aoClicarEmApagar={handleDelete}
          aoClicarEmVoltar={() => {
            navigate('/c4-usuarios');
          }}
          aoClicarEmSalvar={formik.submitForm}
          aoClicarEmSalvarENovo={handleSaveAndNew}
          aoClicarEmNovo={handleNovo}
        />
      }
    >
      <Box>
        <Section title="" margin>
          <Box display="flex" flexDirection="column" gap={2}>
            <Box>
              {!isLoading && (
                <FormControl fullWidth>
                  <FormLabel required>Nome</FormLabel>
                  <TextField
                    sx={{ maxWidth: '445px' }}
                    variant="outlined"
                    name="nome"
                    value={formik.values.nome}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.nome && Boolean(formik.errors.nome)}
                    helperText={formik.touched.nome && formik.errors.nome}
                  />
                </FormControl>
              )}
              {isLoading && (
                <Skeleton
                  variant="rectangular"
                  animation="pulse"
                  height={50}
                  width="445px"
                />
              )}
            </Box>
            <Box>
              {!isLoading && (
                <FormControl fullWidth>
                  <FormLabel required>Descrição</FormLabel>
                  <TextField
                    sx={{ maxWidth: '445px' }}
                    variant="outlined"
                    name="descricao"
                    value={formik.values.descricao}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.descricao &&
                      Boolean(formik.errors.descricao)
                    }
                    helperText={
                      formik.touched.descricao && formik.errors.descricao
                    }
                  />
                </FormControl>
              )}
              {isLoading && (
                <Skeleton
                  variant="rectangular"
                  animation="pulse"
                  height={50}
                  width="445px"
                />
              )}
            </Box>
          </Box>
        </Section>
      </Box>
    </PageLayout>
  );
};
